import React from 'react';
import { CrmContactMainInfo } from './CrmContactMainInfo';
import { IDirectoryEntry, ILinkedDirectoryEntryArrayItem } from 'services/CrmApi/types/DirectoryEntry';
import { CrmContactActivity } from './CrmContactActivity';
import { RouterTabs } from 'ui/RouterTabs';

interface ICrmContactTabsProps {
  directoryEntry: IDirectoryEntry;
  directoryEntryProfileType: string;
  contacts: ILinkedDirectoryEntryArrayItem[];
  companies: ILinkedDirectoryEntryArrayItem[];
  onLinkOrUnlink: () => void;
}

export const CrmContactTabs: React.FC<ICrmContactTabsProps> = ({ directoryEntry, directoryEntryProfileType, contacts, companies, onLinkOrUnlink }) => {
    const crmContactTabs = [
      {
        title: 'Overview',
        route: 'overview',
        styles: 'min-w-[50%]',
        renderContent: () => <CrmContactMainInfo directoryEntryId={directoryEntry.id} profileType={directoryEntryProfileType} contacts={contacts} companies={companies} onLinkOrUnlink={onLinkOrUnlink} />,
      },
      {
        title: 'Activity',
        route: 'activity',
        styles: 'min-w-[50%]',
        renderContent: () => <CrmContactActivity directoryEntryId={directoryEntry.id} />,
      },
    ];
  
    return (
      <RouterTabs tabConfig={crmContactTabs} className="o:w-full o:p-0" tabSelectorClassName="o:m-0" />
    );
}